import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { EEWidgetOptions } from '../text-box/ee-widget-options.model';
import { JsfUtilsService } from '@xm-ngx/ext/ee-core-webapp-ext/jsf-module/jsf-utils.service';

@Component({
    selector: 'xm-ee-basic-widget',
    templateUrl: './basic-widget.component.html',
    styleUrls: ['./basic-widget.component.scss'],
    standalone: false,
})
export class BasicWidgetComponent implements OnInit {

  @Input() public options: EEWidgetOptions;
  @Input() public controlValue: any;
  @Input() public type = 'text';
  @Input() public validators: ValidatorFn[];

  @Output() public valueChanged = new EventEmitter();

  public defaultValidationMessages: {[key: string]: string} =
      this.utils.getDefaultValidationMessages();

  public formControl: FormControl;


  constructor(
      protected utils: JsfUtilsService,
  ) { }

  public ngOnInit(): void {
      this.formControl = new FormControl(this.controlValue, this.validators);
      this.initOptionsFromLayoutNode();
  }

  public onValueChanged($event: any): void {
      this.valueChanged.emit($event);
  }

  public initOptionsFromLayoutNode(): void {
      this.options.validationMessages = {...this.defaultValidationMessages, ...this.options.error};
      if (this.options.readonly) {
          this.formControl.disable();
      }
      if (this.options.required) {
          this.formControl.addValidators([Validators.required]);
      }
      if (this.options.maxValue) {
          this.formControl.addValidators([Validators.max(this.options.maxValue)]);
      }
      if (this.options.minValue) {
          this.formControl.addValidators([Validators.min(this.options.minValue)]);
      }
  }

}
